// extracted by mini-css-extract-plugin
export default {"manage-clients-grid-container":"page_manage-clients-grid-container__ZcOp9","overflow-content":"page_overflow-content__eYwD9"};